import Vue from 'vue';
import type { ExtendedError } from '~/plugins/sentry/types';

export default Vue.extend({
  name: 'WarRoomFetchPostsMixin',
  async asyncData({ store, params, query, res, $auth, redirect, $utils, error, $sentryUtils }) {
    if (!params.topicSlug && !params.categorySlug && !params.tab) {
      error({ statusCode: 404, message: 'Feed not found' });
      return;
    }

    try {
      await Promise.all([
        store.dispatch('warRoom/fetchPosts', { params, query, res }),
        $auth.loggedIn && store.dispatch('warRoom/fetchSidebar'),
      ]);
    } catch (e) {
      $sentryUtils.error(e);

      const page = query?.page && Number(query.page);

      // try to redirect to first page if 404 error, page exist and page > 1
      if ((e as ExtendedError).response?.status === 404 && page && page > 1) {
        redirect({ name: query.name as string });
        return;
      }

      if ((e as ExtendedError).response?.status === 500) {
        $utils.nuxtErrorPage(e as ExtendedError);
        error({ statusCode: 404, message: 'Feed not found' });
        return;
      }

      $utils.nuxtErrorPage(e as ExtendedError);
    }
  },
  watch: {
    async '$auth.loggedIn'(isLoggedIn) {
      if (isLoggedIn) {
        await Promise.allSettled([
          this.$store.dispatch('warRoom/fetchPosts', this.$route),
          this.$store.dispatch('warRoom/fetchSidebar'),
        ]);
      }
    },
  },
});
